import { render, staticRenderFns } from "./BattlesHeaderCreate.vue?vue&type=template&id=727bf38a&scoped=true"
import script from "./BattlesHeaderCreate.vue?vue&type=script&lang=js"
export * from "./BattlesHeaderCreate.vue?vue&type=script&lang=js"
import style0 from "./BattlesHeaderCreate.vue?vue&type=style&index=0&id=727bf38a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727bf38a",
  null
  
)

export default component.exports